module.exports = __webpack_public_path__ + "img/icon-group.ca05925d.svg";